import React from 'react';

const SATFLOW_COLLECTION_URL = 'https://www.satflow.com/ordinals/blockpirates';

function Project() {
    return (
        <section className="tf-section tf-project nft-item satflow-collection-section">
            <div className="satflow-collection-shell" data-aos="fade-in" data-aos-duration="800">
                <iframe
                    title="Block Pirates collection on Satflow"
                    src={SATFLOW_COLLECTION_URL}
                    className="satflow-collection-frame"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    allow="clipboard-read; clipboard-write"
                />
            </div>
        </section>
    );
}

export default Project;
